<template lang="pug">
.campaign__md-contents
  .campaign__md-contents-body(v-html="lastMdContentsHtml")
</template>

<script>
import axios from 'axios'
import marked from'marked'
import {isEmpty} from 'lodash/lodash.min'

export default {

  computed: {
    lastMdContentsHtml: function() {
      if (isEmpty(this.mdContents)) {
        return ''
      }
      return marked(this.mdContents.content, {
        sanitize: true,
        breaks: true
      })
    }
  },

  created() {
    this.load()
  },

  data() {
    return {
      mdContents: '',
      jsonPath: (()=> {
        return location.pathname.replace(/\/$/, '') + '.json'
      })()
    }
  },

  methods: {
    load() {
      const csrf = document.querySelector('meta[name=csrf-token]')
      if (!_.isNull(csrf)) {
        axios.defaults.headers['X-CSRF-TOKEN'] = csrf.getAttribute('content')
      }
      axios.get(this.jsonPath)
        .then((response) => {
          this.mdContents = response.data.result.campaign.last_md_contents
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }

}
</script>

<style lang="sass" scoped>
.campaign__md-contents
  font-size: 13px
</style>
